/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Dienstlichebeurlaubung2Inputs */



/**

* @param {_Class_Dienstlichebeurlaubung2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_dienstlichebeurlaubung2 = /** @type {((inputs?: _Class_Dienstlichebeurlaubung2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Dienstlichebeurlaubung2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Dienstliche Beurlaubung")
});
export { _class_dienstlichebeurlaubung2 as "_class_DienstlicheBeurlaubung" }